import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';

import { environment } from '@environment';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (req.url === environment.loginEndpoint) {
          return throwError(() => error);
        }

        if (error.status === 401 || error.status === 403) {
          this.authService.reloginDialog$.next(true);
          return [];
        }

        return throwError(() => error);
      })
    );
  }
}
